'use strict';

export default class SortBlock {
	constructor(selector) {
		this.container = document.querySelector(`[${selector}-dropdown]`);
		this.btn = document.querySelector(`[${selector}-dropdown-btn]`);
		this.select = document.querySelector(`[${selector}-select]`);

		if(!this.container && !this.btn && !this.select) return false;
		this.init();
	}

	init() {
		let self = this;

		this.btn.addEventListener('click', e => {
			e.preventDefault();
			this.container.classList.toggle('is-open');
		});

		document.addEventListener('click', e => {
			if (!this.container.contains(e.target)){
				this.container.classList.remove('is-open');
			}
		});

		this.select.addEventListener('change', function() {
			let selected = self.select.options[this.selectedIndex];
			if (selected) {
				let asc = selected.getAttribute("data-asc");
				let btnClass = (asc !== null) ? "is-asc" : "is-desc";
				self.btn.parentElement.classList.add(btnClass);
				self.btn.innerText = selected.innerText.trim().replace(/[▼▲]/, "");
			}
			document.location=this.options[this.selectedIndex].value
		});
	}
}
